import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

const BASE_CLASS = 'nui-form-helper-text';
const formHelperTextPropTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  hidden: PropTypes.node
};
const FormHelperText = ({
  className,
  children,
  hidden,
  ...restProps
}) => {
  if (hidden || !children) return null;
  return /*#__PURE__*/React__default.createElement("span", _extends({
    className: cx(BASE_CLASS, className)
  }, restProps), children);
};
FormHelperText.propTypes = formHelperTextPropTypes;
FormHelperText.displayName = 'NuiFormHelperText';
var FormHelperText$1 = FormHelperText;

export { FormHelperText$1 as default };
